import React, { FC } from "react";
import type { PageProps, PostPreview } from "@/types";
import { useRouter } from "next/router";
import { Link } from "../link";
import { ResourcesCta } from "../resources";
import { PostCard } from "../post-card";
import { searchPosts } from "@/util/client/search";

export const Search: FC<PageProps> = (props) => {
  const [searchVal, setSearchVal] = React.useState("");
  const [selectedFilter, setSelectedFilter] = React.useState("");
  const [filteredSearchResults, setFilteredSearchResults] = React.useState<
    PostPreview[]
  >([]);
  const [searchResults, setSearchResults] = React.useState<
    PostPreview[] | null
  >(null);
  const router = useRouter();

  const filterButtons = [
    {
      label: "All",
      value: "",
    },
    {
      label: "Blog",
      value: "blogs",
    },
    {
      label: "News",
      value: "news",
    },
    {
      label: "Insights",
      value: "insights",
    },
  ];

  React.useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const searchQuery = urlParams.get("s");
    if (!searchQuery) {
      router.push("/");
    } else {
      setSearchVal(searchQuery);
      searchPosts(searchQuery)
        .then((items) => {
          setSearchResults(items);
          setFilteredSearchResults(items);
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (selectedFilter && searchResults) {
      setFilteredSearchResults(
        searchResults.filter((result) => result.group === selectedFilter)
      );
    } else if (searchResults) {
      setFilteredSearchResults(searchResults);
    }
  }, [selectedFilter, searchResults]);

  return (
    <div>
      <div className="wrapper">
        <div className="resources--links">
          {props.meta.translation.header.resources.children.map(
            (item, itemIdx) => {
              return (
                <Link
                  key={itemIdx}
                  noStyle
                  href={item.link?.uri || "#"}
                  className="resources--link"
                >
                  {item.text}
                </Link>
              );
            }
          )}
        </div>
        <div className="searchPage--header">
          <div className="searchPage--subtitle">
            Showing <strong>{filteredSearchResults.length} results</strong>
          </div>
          <h1 className="searchPage--title">
            Search results for <strong>‘{searchVal}’</strong>
          </h1>
          <div className="searchPage--filters">
            {filterButtons.map((filter, index) => {
              return (
                <button
                  key={index}
                  className={`searchPage--filter ${
                    selectedFilter === filter.value
                      ? "searchPage--filter_active"
                      : ""
                  }`}
                  onClick={() => {
                    setSelectedFilter(filter.value);
                  }}
                >
                  {filter.label}
                </button>
              );
            })}
          </div>
        </div>
        {filteredSearchResults.length > 0 && (
          <div className="resourcesPage--latest">
            <div className="wrapper">
              <div className="resourcesPage--list">
                {filteredSearchResults.slice(0, 4).map((result, index) => {
                  return (
                    <PostCard
                      key={index}
                      card={result}
                      theme="dark"
                      readMore={props.meta.translation.resources.readMore}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="wrapper wrapper_lg">
        <ResourcesCta title="Sign up for the newsletter to stay in the know" />
      </div>
      <div className="wrapper">
        {filteredSearchResults.length > 4 && (
          <div className="resourcesPage--rest">
            <div className="wrapper">
              <div className="resourcesPage--list">
                {filteredSearchResults.slice(4).map((result, index) => {
                  return (
                    <PostCard
                      key={index}
                      card={result}
                      theme="dark"
                      readMore={props.meta.translation.resources.readMore}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
